import { useEffect, useRef, useState } from 'react';
import UserStatusService from 'services/userStatusService';

export const useUserStatusMonitoring = () => {
  const [user, setUser] = useState<any>(null);
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
  const statusServiceRef = useRef<UserStatusService | null>(null);

  // Get user from localStorage
  useEffect(() => {
    const getUserFromStorage = () => {
      try {
        const userDetails = localStorage.getItem('userDetails');
        const authUser = localStorage.getItem('authUser');
        
        if (userDetails && authUser) {
          const userData = JSON.parse(userDetails);
          setUser(userData);
          setIsAuthenticated(true);
        } else {
          setUser(null);
          setIsAuthenticated(false);
        }
      } catch (error) {
        console.error('Error parsing user data from localStorage:', error);
        setUser(null);
        setIsAuthenticated(false);
      }
    };

    getUserFromStorage();

    // Listen for storage changes
    const handleStorageChange = () => {
      getUserFromStorage();
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  useEffect(() => {
    // Only start monitoring if user is authenticated
    if (isAuthenticated && user) {
      if (!statusServiceRef.current) {
        statusServiceRef.current = UserStatusService.getInstance();
      }
      
      // Start monitoring
      statusServiceRef.current.startMonitoring();
    }

    // Cleanup function
    return () => {
      if (statusServiceRef.current) {
        statusServiceRef.current.stopMonitoring();
      }
    };
  }, [isAuthenticated, user]);

  // Return the status service instance for manual operations
  return {
    statusService: statusServiceRef.current,
    isMonitoring: statusServiceRef.current?.isMonitoring() || false
  };
};
